<sk-modal-content [title]="'label.Selection' | translate"
                  cancelBtnText="label.Close"
                  confirmByKeypress
                  (confirmed)="accept()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()"
                  [allowCancelIfChildFocused]="true"
                  [allowConfirmIfChildFocused]="true">
  <ng-container id="sk-modal-body">
    <form #departmentSelectionForm="ngForm" name="DepartmentSelectionForm"
      class="form-horizontal department-selection-form">
      @for (node of selection; track $index; let nodeIndex = $index) {
        <sk-select
          skSelectSortItems
          [name]="'selection_' + nodeIndex"
          [items]="dSources[nodeIndex]"
          [required]="options.required || (options.downLevel > 1 && options.onlyLeaf && !(options.downLevel - 1 == nodeIndex) )"
          (ngModelChange)="processSelection($event, nodeIndex)"
          [ngModel]="selection[nodeIndex]"
          bindLabel="name"
          bindValue="id"
        >
        </sk-select>
      }
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons-left">
    <sk-button
      (click)="setEmpty($event)"
      [appearance]="'link'"
      [label]="'label.SetEmpty' | translate"
      [color]="'primary'">
      <ng-template buttonPrefix>
        <i class="fa-fw fas fa-eraser"></i>
      </ng-template>
    </sk-button>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.SetSelection' | translate"
      data-test="modal-footer-confirm-button"
      [disabled]="!departmentSelectionForm.valid"
      (click)="accept()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
